<template>
  <div id="content">
      <div class="productbg">
        <img src="./images/productbg.jpg" />
      </div>
    <div id="product">
      <div class="productcenterdiv">
      <div class="nav_1">
      <div class="productNav">
        {{ $t("header.product_info") }}
      </div>
        <div v-for="cl in classs"
             :key="cl.id">
          <a @click="changeclass(cl.id)"
             v-if="$route.params.id == cl.id"
             :href="'/#/product/' + cl.id"
             class="on">
            <span v-if="$i18n.locale == 'en'">{{ cl.name_en }}</span>
            <span v-else>{{ cl.name }}</span>
          </a>
          <a v-else
             :href="'/#/product/' + cl.id"
             @click="changeclass(cl.id)">
            <span v-if="$i18n.locale == 'en'">{{ cl.name_en }}</span>
            <span v-else>{{ cl.name }}</span>
          </a>
        </div>
        <!-- <a href="list.php?pid=2&amp;ty=13" class="on">遥控车系列</a> -->
        <div class="clear"></div>
      </div>
      <div class="product">
        <ul>
          <li v-for="p in products.Items"
              :key="p.ID">
            <a :href="'/#/productdetail/'+p.ID"
               target="_blank"><img :src="p.prod_image"
                   alt="" /></a>
            <span class="le"
                  v-if="$i18n.locale=='en'">{{p.prod_enname}}</span>
            <span class="le"
                  v-else>{{p.prod_name}}</span>
            <em><a v-if="$i18n.locale=='en'"
                 :href="'/productdetail/'+p.id">+MORE</a>
              <a v-else
                 :href="'/#/productdetail/'+p.id">+了解更多</a></em>
          </li>
        </ul>
      </div>
      <!-- <div class="page">
        <a href="javascript:void()">首页</a>
        <a href="javascript:void()">&lt;</a>
        <a href="javascript:void()" class="on">1</a>
        <a href="?pid=2&amp;ty=13&amp;page=2">2</a>
        <a href="?pid=2&amp;ty=13&amp;page=3">3</a>
        <a href="?pid=2&amp;ty=13&amp;page=2">&gt;</a>
        <a href="?pid=2&amp;ty=13&amp;page=3">末页</a>
      </div> -->
    </div>

    <div>
      <div class="m b10">&nbsp;</div>
      <el-pagination background
                     layout="prev, pager, next"
                     :page-count="products.TotalPages"
                     @current-change="changePage">
      </el-pagination>
    </div>
    </div>
  </div>
</template>

<script>
import fetch from "@/utils/axios";
export default {
  components: {},
  name: "Product",
  data () {
    return {
      classs: [],
      products: {},
      page_index: 1,
      big_class: 0,
      keyword: 0,
      keywordinfo: {},
    };
  },
  created () {
    this.big_class = this.$route.params.id
    this.keyword = this.$route.params.key
  },
  mounted () {
    // 使用
    const params = { id: 1 }; // 参数
    fetch.post("/api/ApiProClass/GetWebHomeClassByParentId", params).then(
      (res) => {
        this.classs = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
    this.changePage(1)
    // const productparam = { page_index: this.page_index, key: this.keyword }; // 参数
    // if (this.big_class != 0) {
    //   productparam.big_class = this.big_class;
    // }
    // fetch.post("/api/ApiProduct/QueryPageProductList", productparam).then(
    //   (res) => {
    //     this.products = res;
    //   },
    //   (error) => {
    //     alert(JSON.stringify(error));
    //   }
    // );
  },
  methods: {
    changeclass (cl) {
      this.big_class = cl;
      this.changePage(1);
    },
    changePage (pageIndex) {
      this.keywordinfo = { 'bigclassid':1,'smallclassid': this.big_class,'type': this.big_class, 'keyword': this.keyword };
      const productparam = { page_index: pageIndex, page_size: 9, keyword: JSON.stringify(this.keywordinfo) }; // 参数
      if (this.big_class != 0) {
        productparam.big_class = this.big_class;
      }
      fetch.post("/api/ApiProduct/QueryPageProductList", productparam).then(
        (res) => {
          this.products = res;
          window.scrollTo(0, 0)
        },
        (error) => {
          alert(JSON.stringify(error));
        }
      );
    },
  },

  scrollToBottom: function () {
    alert('scrollToBottom')
  }
};
</script>

<style>
#product {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f5f5f5;
}
.productbg{
  margin: 0px;
padding: 0px;
height: 300px;
}
.productbg img{
  margin: 0px;
padding: 0px;
}
.productcenterdiv {
  width: 1400px;
  display: flex;
  margin: 0 auto;
}
.nav_1{
  flex:0 0 24%;
  margin: 30px 1% auto;
  text-align: left;
}
.productNav{
  background-color: orange;
  color: white;
  font-weight: bolder;
  font-size: 30px;
  width: 100%;  line-height: 80px;
  text-indent: 20px;
  position: relative;border-radius: 20px 0 0 0;
}

.nav_1 a {
  display: block;
  float: left;
  text-align: left;
  font-size: 16px;
  color: #333;
  width: 100%;  
  line-height: 60px;
  background: white;
  border-bottom: 1px #dbdbdb solid;
  text-indent: 20px;
}
.nav_1 a:hover {
  background: #00a0e9;
  color: #fff;
  border-bottom: 3px #028fcf solid;
}
.nav_1 a.on {
  background: #00a0e9;
  color: #fff;
  border-bottom: 3px #028fcf solid;
}

.product {
  flex:0 0 75%;
  overflow: hidden;
  margin: 5px auto auto;
}
.product ul {
}
.product li {
  float: left;
  width: 308px;
  display: inline-block;
  padding: 9px;
  background-color: white;
  margin-top: 25px;
  margin-right: 17px;
}
.product li img {
  display: block;
  border: 0;
  width: 308px;
  height: 231px;
  overflow: hidden;
}
.product li span {
  display: block;
  text-align: left;
  width: 100%;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  margin-top: 4px;
}
.product li em {
  display: block;
  text-align: right;
  font-style: normal;
  font-size: 12px;
  line-height: 24px;
}
.product li em a {
  color: #999;
}
.product li:hover {
  background: #00a0e9;
}
.product li:hover span {
  color: #fff;
}
.product li:hover em a {
  color: #fff;
}

.page {
  width: 1100px;
  margin: 40px auto;
  text-align: center;
  font-size: 12px;
  color: #333;
}
.page a {
  color: #333;
  padding: 7px 12px;
  border: 1px #ccc solid;
  margin: 0px 2px;
}
.page a:hover {
  border: 1px #01a4e9 solid;
  background: #01a4e9;
  color: #fff;
}
.page span {
  padding: 7px 12px;
  background: #01a4e9;
  color: #fff;
  border: 1px #01a4e9 solid;
  margin: 0px 2px;
}
</style>



// WEBPACK FOOTER //
// src/Product.vue